import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { getUserContext } from "../../../configs/utils";
import { ROUTE } from "../../../routes";
export const doneAction = async (action, _datastore, { navigateWithClear, network }) => {
    await getUserContext(network, {
        overrideCache: true
    });
    await navigateWithClear(ROUTE.DASHBOARD, { cacheUserContext: true });
};
export const navigateToForeclosureScreen = async (action, _datastore, { goBack, navigate, network }) => {
    const user = await SharedPropsService.getUser();
    const creditId = user?.linkedCredits[0]?.creditId;
    const getLoanDetails = await network.get(`${api.getLoanDetails}${creditId}`, { headers: await getAppHeader() });
    await navigate(ROUTE.CONFIRM_LOAN_DETAILS, { getLoanDetails });
};
